import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { CorreiosAuth, CorreiosServices } from 'src/app/services/correios.services';
import { DialogService } from 'src/app/services/dialog.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { PromptField, PromptSaveDialogComponentMultiple } from 'src/app/system-utils/prompt-save-dialog-multiple/prompt-save-dialog-multiple.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
//import xml2js from 'xml2js'
import { StringUtils } from 'src/app/system-utils/utils/StringUtils';

@Component({
    selector: 'cep-consultapreco',
    templateUrl: './cep-consultapreco.component.html',
    styleUrls: ['./cep-consultapreco.component.scss'],
    standalone: false
})
export class CepConsultaprecoComponent implements OnInit {
  info: { title: string; fields:PromptField[]};
  mensagemObj = [];

  constructor(private fb:UntypedFormBuilder, 
              private cs:CorreiosServices, 
              private snackService:SnackbarService,
              private dialog:DialogService,
              private ucs:UserConfigServices,
              private uid:UserAuthenticationServices ) { }

  @Input() codecompany:number;
  @Input() codecontract:number;
  @Input() servico:Object;
  @Input() correiosAuth:CorreiosAuth;
  formValidation:UntypedFormGroup;
  @Input() eventUserConfig: Observable<object>;
  private eventsSubscription: Subscription;
  userConfig = {};
  

  ngOnInit(): void {
      this.formValidation = this.fb.group({
        origem: new UntypedFormControl(null,[Validators.required,Validators.minLength(8),Validators.maxLength(8)]),
        destino: new UntypedFormControl(null,[Validators.required, Validators.minLength(8),Validators.maxLength(8)]),
        peso: new UntypedFormControl("1",[Validators.required]),
        altura: new UntypedFormControl("1",[Validators.required]),
        largura: new UntypedFormControl("1",[Validators.required]),
        diametro: new UntypedFormControl("0",[Validators.required]),
        comprimento: new UntypedFormControl("1",[Validators.required]),
        vlrdeclarado: new UntypedFormControl('0',[Validators.required])
    });

    this.eventsSubscription = this.eventUserConfig.subscribe(value=>{
      this.userConfig = value;
      this.loadXstruct();  
    });
    
  }

  ngOnDestroy(){
      this.eventsSubscription.unsubscribe();
  }

  loadXstruct(){
    
    this.info = {
      title:'Preferências',
      fields:[]
    }

    if ( this.userConfig ){
      if (this.userConfig['consultapreco']){
        this.info.fields = JSON.parse(this.userConfig['consultapreco']);
        return;
      }
    }    

    this.info.fields= [{
          controlName:"maosproprias",
          label:"Mãos Próprias",
          type:"options",
          mensagem:"Não informado o mãos próprias.",
          options:[{
              key:"S",
              value: "Sim"
          },
          {
            key:"N",
            value:"Não"
          }
          ]
        },
        {
          controlName:"formato",
          label:"Formato",
          mensagem:"Não informado o formato.",
          type:"options",
          options:[{
              key:"1",
              value:'Caixa/Pacote'
          },
          {
            key:"2",
            value:'Rolo/Prisma'
          },
          {
            key:"3",
            value:'Envelope'
          }

          ]
        },
        {
          controlName:"avisorecebimento",
          type:"options",
          label:"Aviso de Recebimento",
          mensagem:"Não informado o aviso de recebimento.",
          options:[{
              key:"S",
              value: "Sim"
            },
            {
              key:"N",
              value:"Não"
            }]
        }]
  }

  clear(campo:string){
    this.formValidation.get(campo).setValue(null);
  }

  openConfig(){
    
    this.dialog.openGenericDialog(PromptSaveDialogComponentMultiple,this.info,(data)=>{
        this.info.fields = JSON.parse(data) as PromptField[];
        
        let jsonDec:Object ={
          "entityName":"Mktpdic",
          "condition":`instancename='Mktpetqrange'`
        };
        
        this.userConfig['consultapreco'] = JSON.stringify(this.info.fields);
        
        this.ucs.saveUserCfg(jsonDec,this.uid.user.iduser,null,this.userConfig).then(me=>{
        });    
  
    });

  }

  consultar(){

    if ( !this.formValidation.valid ){
      this.formValidation.markAllAsTouched();
      return;
    } 

    if ( this.servico == null ){
        this.snackService.showError("Para pesquisar preço, deve-se selecionar um serviço.");
        return;
    }

    let infoFields = {
        peso: this.formValidation.get('peso').value,
        comprimento: this.formValidation.get('comprimento').value,
        altura: this.formValidation.get('altura').value,
        largura: this.formValidation.get('largura').value,
        diametro: this.formValidation.get('diametro').value,
        maospropria: this.info.fields.find(d=>d.controlName=='maosproprias').value,
        avisorecebimento: this.info.fields.find(d=>d.controlName=='avisorecebimento').value,
        vlrdeclarado: 0,
        formato: 0
    }

    this.cs.getPrecoPrazo(
              this.codecompany, 
              this.codecontract, 
              this.servico, 
              this.formValidation.get("origem").value,
              this.formValidation.get("destino").value,
              this.formValidation.get("vlrdeclarado").value,
              infoFields,
              this.correiosAuth).then(data=>{
                
                // const p: xml2js.Parser = new xml2js.Parser();
                // p.parseString(data, (err, result) => {
                //   if (err) {
                //     throw err;
                //   }
                  
                //   let json:string  = JSON.stringify(result, null, 4); 
                //   json = json.replace(/soap:/g,'');
                //   let JSONObject = JSON.parse(json);
                //   let servico = ObjectUtil.FindObject(JSONObject,'$.Envelope.Body[0].CalcPrecoPrazoResponse[0].CalcPrecoPrazoResult[0].Servicos[0].cServico[0]');
                  
                  
                //   let Valor = getValue(servico, 'Valor');
                //   let PrazoEntrega = getValue(servico,'PrazoEntrega');
                //   let ValorMaoPropria = getValue(servico,'ValorMaoPropria');
                //   let ValorAvisoRecebimento = getValue(servico,'ValorAvisoRecebimento');
                //   let ValorValorDeclarado = getValue(servico,'ValorValorDeclarado');
                //   let EntregaDomiciliar = getValue(servico,'EntregaDomiciliar');
                //   let EntregaSabado = getValue(servico,'EntregaSabado');
                //   let ValorSemAdicionais = getValue(servico,'ValorSemAdicionais');
                //   let obsFim = getValue(servico,'obsFim');
                //   let MsgErro = getValue(servico,'MsgErro')
                //       let oj:Object[]  = [];

                //       let mensagem = '';

                //       if ( Valor != null){
                //         oj.push({key:'Valor', value:Valor});
                //       }
                      
                //       if ( PrazoEntrega!=null ){
                //         oj.push({key:'Prazo', value:PrazoEntrega});
                //       }

                //       if ( ValorMaoPropria != null){
                //         oj.push({key:'Vlr. Mão Própria', value:ValorMaoPropria});
                //       }
                      
                //       if ( ValorAvisoRecebimento!=null ){
                //         oj.push({key:'Vlr. Aviso Recebimento', value:ValorAvisoRecebimento});
                //       }

                //       if ( ValorValorDeclarado != null){
                //         oj.push({key:'Vlr. Declarado', value:ValorValorDeclarado});
                //       }

                //       if (ValorSemAdicionais!=null ){
                //         oj.push({key:'Vlr. S/ Adicionais', value:ValorSemAdicionais});
                //       }

                //       if ( EntregaDomiciliar != null ){
                //         oj.push({key:'Ent. Domiciliar', value:EntregaDomiciliar});
                //       }
                      
                //       if ( EntregaSabado!= null ){
                //         oj.push({key:'Ent. Sábado', value:EntregaSabado});
                //       }
                      
                //       if ( obsFim != null ){
                //         oj.push({key:'Observações', value:obsFim});
                //       }
                      
                //       if ( MsgErro != null && MsgErro!=''){
                //         oj = [];
                //         oj.push({key:'Erro', value:MsgErro});
                //       }

                //       this.mensagemObj = oj;

                      
                // });

              })
  }
}
function getValue(servico: any, path:string) {
  try{
    return servico[0][path][0];
  }catch(Exception){
    return null;
  }
}

